import script from "./placeInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./placeInformation.vue?vue&type=script&setup=true&lang=js"

import "./placeInformation.vue?vue&type=style&index=0&id=0ce3a821&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce3a821"]])

export default __exports__